import { render, staticRenderFns } from "./QuoteAttachmentCategoryModal.vue?vue&type=template&id=8db7f1e8"
import script from "./QuoteAttachmentCategoryModal.vue?vue&type=script&lang=js"
export * from "./QuoteAttachmentCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8db7f1e8')) {
      api.createRecord('8db7f1e8', component.options)
    } else {
      api.reload('8db7f1e8', component.options)
    }
    module.hot.accept("./QuoteAttachmentCategoryModal.vue?vue&type=template&id=8db7f1e8", function () {
      api.rerender('8db7f1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteAttachmentCategoryModal.vue"
export default component.exports